/**
 * 模块 - 通话中心 - 英文
 */
export default {
  callCenter: {
    signIn: 'Sign In',
    signOut: 'Sign Out',
    setIdle: 'Set Idle',
    setBusy: 'Set Busy',
    hangup: 'Hang Up',
    monitor: 'Monitor',
    signInSuccess: 'Signed in successfully',
    signOutSuccess: 'Signed out successfully',
    setIdleSuccess: 'Set to idle successfully',
    setBusySuccess: 'Set to busy successfully',
    notSignedIn: 'Not Signed In',
    idle: 'Idle',
    busy: 'Busy',
    onCall: 'On Call',
    all: 'All',
    callDuration: 'Call Duration',
    todayCallCount: 'Today\'s Calls',
    beginCallout: 'Begin Outbound',
    endCallout: 'End Outbound',
    // Call center settings
    addBinding: '+ Add Binding',
    operation: 'Operation',
    unbind: 'Unbind',
    unbindConfirm: 'Unbind Confirmation',
    unbindConfirmText: 'After unbinding, the extension number and campus binding will be automatically removed. The campus will no longer be able to use it. Confirm unbind?',
    addBindTitle: 'Add Binding',
    campusId: 'Campus ID',
    pleaseEnterCampusId: 'Enter campus ID',
    trafficSystem: 'Traffic System',
    pleaseSelectTrafficSystem: 'Select traffic system',
    hantianSystem: 'Hantian Traffic System',
    yixunSystem: 'Yixun Traffic System',
    extNo: 'Extension No.',
    agentNo: 'Agent No.',
    pleaseEnterExtNo: 'Enter extension no.',
    pleaseEnterAgentNo: 'Enter agent no.',
    outboundDisplayPhone: 'Outbound Display Phone',
    pleaseEnterOutboundPhone: 'Enter outbound display phone',
    outboundPhoneTip: 'Note: Outbound display phone currently supports mobile numbers only',
    addExtSeat: '+ Add Extension & Seat',
    delete: 'Delete',
    cancel: 'Cancel',
    confirm: 'Confirm',
    campusName: 'Campus Name',
    bindUser: 'Operator',
    bindTime: 'Operation Time',
    unbindSuccess: 'Unbound successfully',
    unbindFail: 'Unbind failed',
    pleaseEnterCampusIdErr: 'Please enter campus ID',
    pleaseSelectTrafficSystemErr: 'Please select traffic system',
    pleaseEnterExtNoErr: 'Please enter extension no.',
    pleaseEnterAgentNoErr: 'Please enter agent no.',
    operationSuccess: 'Operation successful',
    operationFail: 'Operation failed',
    campus: 'Campus',
    pleaseEnterExtNoPlaceholder: 'Enter extension no.',
    pleaseEnterAgentNoPlaceholder: 'Enter agent no.',

    // Workbench
    workbenchTitle: 'Outbound Workbench',
    realPhone: 'Real Phone:',
    displayPhone: 'Display Phone:',
    callNow: 'Call Now',
    endCall: 'End Call',
    followPerson: 'Follower:',
    followInfo: 'Follow Info:',
    more: 'More',
    noFollowYet: 'This lead has not been followed up',
    cluePhone: 'Lead Phone:',
    clueSource: 'Lead Source:',
    studentName: 'Student Name',
    grade: 'Grade',
    familyMember1: 'Family Member 1',
    familyMember2: 'Family Member 2',
    pleaseFill: 'Please fill in',
    pleaseSelect: 'Please select',
    queryTimeRange: 'Query Time Range',
    belongToAgent: 'Belong To Agent',
    callType: 'Call Type',
    callDurationRankQueryTime: 'Query Time',
    callDurationRankCustomerService: 'Customer Service',
    callDurationRankNamePlaceholder: 'Name',
    callDurationRankCallType: 'Call Type',
    callTime: 'Call Time',
    recordDuration: 'Record Duration',
    statusPlaceholder: 'Status',
    callDurationRankAgentName: 'Agent Name',
    agentStatus: 'Agent Status',
    todayFirstSignInTime: 'Today\'s First Sign-In Time',
    lastCallTime: 'Last Call Time',
    todayConnectedCount: 'Today\'s Connected Count',
    todayTotalCallDuration: 'Today\'s Total Call Duration',
    callDurationRankFirstCall: 'First Call',
    callDurationRankLastCall: 'Last Call',
    callDurationRankCallCount: 'Call Count',
    callDurationRankConnectedCount: 'Connected Count',
    callDurationRankEffectiveConnectedCount: 'Effective Connected Count',
    callDurationRankConnectedRate: 'Connected Rate',
    callDurationRankCallDuration: 'Call Duration',
    callDurationRankTotalCallDuration: 'Total Call Duration',
    callDurationRankAverageCallDuration: 'Average Call Duration',
    callDurationRankType: 'Type',
    callDurationRankBelongCampus: 'Affiliated Campus',
    today: 'Today',
    last7Days: 'Last 7 Days',
    last30Days: 'Last 30 Days',
    inbound: 'Inbound',
    outbound: 'Outbound',
    callerNo: 'Caller No.',
    calleeNo: 'Callee No.',
    pleaseEnterCallerNo: 'Enter caller no.',
    pleaseEnterCalleeNo: 'Enter callee no.',
    record0_15: '0s-15s',
    record15_30: '15s-30s',
    record30_60: '30s-1min',
    record60_180: '1min-3min',
    record180_300: '3min-5min',
    record300_600: '5min-10min',
    record600Plus: 'Over 10min',
    phonePlaceholder: 'Phone number',
    gradeEditOnce: 'Grade can only be modified once',
    studentGender: 'Student Gender',
    school: 'School',
    birthday: 'Birthday',
    homeAddress: 'Home Address',
    intentLevel: 'Intent Level',
    tag: 'Tag',
    remark: 'Remark',
    followStatus: 'Follow Status',
    nextFollowTime: 'Next Follow Time',
    pleaseSelectFollowStatus: 'Select follow status',
    promiseVisitTime: 'Promise Visit Time:',
    visitTime: 'Visit Time:',
    selectPromiseVisitTime: 'Select promise visit time',
    selectVisitTime: 'Select visit time',
    visitStore: 'Visit Store:',
    pleaseSelectVisitStore: 'Select visit store',
    followDesc: 'Follow Description:',
    transferClue: 'Transfer Lead',
    saveRecord: 'Save Record',
    saveSuccess: 'Saved successfully',
    saveFail: 'Save failed',
    stageK1: 'Pre-K',
    stageK2: 'K1',
    stageK3: 'K2',
    grade1: 'Grade 1',
    grade2: 'Grade 2',
    grade3: 'Grade 3',
    grade4: 'Grade 4',
    grade5: 'Grade 5',
    grade6: 'Grade 6',
    grade7: 'Grade 7',
    grade8: 'Grade 8',
    grade9: 'Grade 9',
    gradeH1: 'Grade 10',
    gradeH2: 'Grade 11',
    gradeH3: 'Grade 12',
    gradeH4: 'Grade 13',
    gradeCommon: 'General',
    followPhone: 'Called',
    followWechat: 'WeChat Added',
    followPromise: 'Promise Visit',
    followVisit: 'Visited',
    followInvalid: 'Invalid',
    followDeal: 'Deal Closed',
    callMakecall: 'Initiating Call',
    callOutcall: 'Connected',
    callOutringing: 'Agent Ringing',
    callConnecting: 'Connecting',
    callAfter: 'Call Ended',
    callAgentidle: 'Agent Idle',
    callCalling: 'Calling',
    callPlaytts: 'Playing Greeting',
    callIncall: 'Agent Answering',
    callAnswer: 'On Call',
    totalCallDuration: 'Total Call Duration',
    totalCallCount: 'Total Call Count',
    successRate: 'Connection Rate',
    effectiveVsTotal: 'Effective / Total',
    avgCallDurationLabel: 'Average Call Duration',
    minutesUnit: 'min',
    addCallButton: 'Add Call',
    showOnlyUnanswered: 'Show Unanswered Only',
    callerColumn: 'Caller',
    callTypeColumn: 'Call Type',
    leadNameColumn: 'Lead Name',
    leadPhoneColumn: 'Lead Phone',
    callTimeColumn: 'Call Time',
    phoneStatusColumn: 'Phone Status',
    callDurationColumn: 'Duration',
    callRecordingColumn: 'Recording',
    playText: 'Play',
    downloadText: 'Download',
    followStatusColumn: 'Follow Status',
    viewFollowRecord: 'View Follow Records',
    newCallDialogTitle: 'Add Call',
    newCallInputLabel: 'Enter the phone number to call',
    newCallInputPlaceholder: 'Enter',
    redialTooltip: 'Redial',
    recordingDialogTitle: 'Call Recording Playback',
    recordingLeadPhoneLabel: 'Lead Phone:',
    recordingCallerLabel: 'Caller:',
    cancelOrderConfirmText: 'Confirm to cancel this order? Once cancelled, the paid amount will be refunded to the corresponding agent account and the futures order quota will be adjusted.',
    payDeductTip: 'This payment will deduct:',
    unopenedTitle: 'Outbound Call Not Activated',
    unopenedMessage: 'Your outbound call service is not activated. Click "Activate" to activate or renew.',
    thinkAgain: 'Maybe Later',
    goToOpen: 'Activate',
    overdueTitle: 'Outbound Call Overdue',
    overdueMessage: 'Your outbound call service has exceeded the usage quota. Click "Recharge" to top up.',
    goToRecharge: 'Recharge',
    paySuccessResult: 'Successfully paid ¥{money}',
    payFailResult: 'Payment failed ¥{money}',
    iKnow: 'Got it',
    male: 'Male',
    female: 'Female',
    indicatorTipIntro: 'Based on your current query time, call duration, follow-up status, number status,<br>caller, and lead filters',
    totalCallDurationFormula: 'Total call duration = sum of all outbound call durations under current filters',
    totalCallCountFormula: 'Total call count = total number of outbound records under current filters',
    successRateFormula: 'Connection rate = connected outbound records / total outbound records × 100%',
    effectiveEfficiencyFormula: 'Effective efficiency = average connected outbound count per caller per day under current filters',
    totalEfficiencyFormula: 'Total efficiency = average total outbound count per caller per day under current filters',
    avgCallDurationFormula: 'Average call duration = average call duration of all outbound records under current filters',
    presalePrice: 'Presale Price',
    originalPrice: 'Original ¥406',
    providerTip: 'Same provider as Zuoyebang, Yuanfudao',
    providerTipPrefix: '*Outbound technology by',
    operatorTip: '*Covers three operators across regions',
    localNumberTip: 'No need to prepare numbers',
    localNumberTipPrefix: '*System assigns local display numbers,',
    markTip: 'Addresses number marking and blocking',
    markTipPrefix: '*Can',
    newOpenTip: '*New activation',
    newOpenTipSuffix: 'requires one-time tech activation fee; no repeat charge on renewal',
    monthlyTipPrefix: '*Monthly billing,',
    monthlyTip: 'Unlimited users',
    openFeeLabel: 'Activation Fee:',
    openFeeDiscount: 'Limited 10% off, original 288.00',
    packageFeeLabel: 'Package Fee:',
    packageFeeDetail: 'Unlimited users, 500 free minutes/month, 0.12/min over',
    openMonthsLabel: 'Months:',
    monthUnit: 'month(s)',
    presaleMaxMonths: 'Presale max 12 months',
    payTipPrefix: 'Please read and check the outbound service',
    agreementLinkText: 'Agreement',
    totalLabel: 'Total:',
    yuanUnit: 'CNY',
    validityMonths: '/valid for {months} month(s)',
    payCancel: 'Cancel',
    payConfirm: 'Pay',
    voucherAccount: 'Voucher Account',
    cashAccount: 'Cash Account',
    goldAccount: 'Gold Account',
    deliveryAccount: 'Delivery Voucher Account',
    accountYuan: '{amount}'
  }
}
